import React from 'react';
import PropTypes from 'prop-types';

import ManagedFormGroup from 'components/form/managed_input/form_group';

export default function PlanStartDate({ disabled, plan, onChange, ...props }) {
  return (
    <ManagedFormGroup
      disabled={disabled}
      label={`${plan.resetPeriod > 1 ? 'Next' : ''} Reset Date`}
      name="startDate"
      required
      type="dateDropdown"
      value={plan.nextPeriodStarts}
      yearsOffset={plan.resetPeriod}
      onChange={onChange}
      {...props}
    />
  );
}

PlanStartDate.propTypes = {
  disabled: PropTypes.bool,
  plan: PropTypes.shape({
    resetPeriod: PropTypes.number,
    nextPeriodStarts: PropTypes.string,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
};
